import React, { lazy, Suspense } from 'react';

const LazyLichTrinhTaiXe = lazy(() => import('./LichTrinhTaiXe'));

const LichTrinhTaiXe = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyLichTrinhTaiXe {...props} />
  </Suspense>
);

export default LichTrinhTaiXe;
